<template>
  <div class="card card-chart" id="wilayahDivBar">
    <div class="card-header mt-2" style="font-weight: 700">
      <h4 class="card-title">Produk Populer</h4>
    </div>
    <div class="card-body mb-5 mt-4 text-center">
      <!-- <div class="text-center">
        <i
          class="fas fa-box-open text-primary filterImg mb-4 floatTrigger float"
          aria-hidden="true"
          style="font-size: 500%; font-weight: 600"
        ></i>

        <p class="text-secondary">Start creating your first content</p>
        <a href="#" class="text-primary">Create a Product</a>
      </div> -->
      <i class="fas fa-box text-primary filterImg" aria-hidden="true" style="font-size: 40px; font-weight:600 "></i>
      <div class="table-responsive mt-4">
        <table class="table table-nowrap table-condensed ">
          <thead>
            <tr class="table-condensed text-left">
              <th>Kode</th>
              <th>Nama</th>
              <th>Qty</th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="proPod in popularProduct" :key="proPod.id" class="text-left" data-toggle="tooltip" data-placement="top" :title="'Qty : '+proPod.total ">
              <td style="width: 10%">
                <p class="mb-0 text-muted text-truncate d-inline-block text-truncat" style="max-width: 50px; ">
                  {{proPod.code}}
                </p>
              </td>
              <td style="width: 40%">
                <p class="mb-0 text-muted text-truncate d-inline-block text-truncat " style="max-width: 150px;" > {{proPod.name}}</p>
              </td>

              <!-- <td style="width: 40%">
                                <div class="progress bg-transparent progress-sm">

                                    <div class="progress-bar text-right rounded" role="progressbar"
                                        style="background-color:#eb596e ; width:{{($item->total / $allProdPop->max('total'))*100}}%"
                        aria-valuenow="{{$item->total}}" aria-valuemin="0" aria-valuemax="100">
        </div>
    </div>
    </td>  -->

              <td style="width: 10%">
                <h5 class="mb-0" style="">
                   {{proPod.total}}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';
  export default {
     data() {
    return {
      popularProduct:{}
    }
  },
  created() {
    this.attrDashboard();
  },
  methods: {
    attrDashboard(){
      let dashboardUrl = "seller/dashboard";
       axios.get(dashboardUrl)
      .then((response) => {
        return response.data.data;
      })
      .then((data) => {
        // console.log(data.sectionStatistic.popularProduct)
        this.popularProduct = data.sectionStatistic.popularProduct
      })
      .catch((err) => {
        console.log(err)
      })
    }
  },
  }
</script>

<style scoped>
.table{
    width: 100%;
}

@media (max-width: 1410px) {
    .table {
        width: 100%;
    }
}

@media (max-width: 517px) {
    .table {
        width: 100%;
    }
}
</style>